import {
  BuildNewCoachesOptionsParams,
  NEW_COACHES_OPTIONS,
  NEW_COACHES_OPTIONS_TEAMS_ORG_SR,
} from '../constants/newCoachesOptions.constant';

export function buildNewCoachesOptions({
  ffTeamsOrgSR,
  reportHeading,
  onSelect,
}: BuildNewCoachesOptionsParams) {
  const isNewOrg = reportHeading === 'New Organization Coaches';
  const isNewFrontline = reportHeading === 'New Frontline Coaches';

  const baseOptions = ffTeamsOrgSR
    ? NEW_COACHES_OPTIONS_TEAMS_ORG_SR
    : NEW_COACHES_OPTIONS;

  return baseOptions.map(option => {
    let selected = option.defaultVal;

    if (isNewOrg || isNewFrontline) {
      selected = ffTeamsOrgSR ? option.id === 'current' : option.id === '30';
    }

    return {
      ...option,
      selected,
      onPress: () => onSelect(option.id),
    };
  });
}

export function getDefaultNewCoachesOptions(ffTeamsOrgSR: boolean) {
  return ffTeamsOrgSR ? NEW_COACHES_OPTIONS_TEAMS_ORG_SR : NEW_COACHES_OPTIONS;
}
